import { render, staticRenderFns } from "./PayingMinimum.vue?vue&type=template&id=35055b83&scoped=true&"
import script from "./PayingMinimum.vue?vue&type=script&lang=ts&"
export * from "./PayingMinimum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35055b83",
  null
  
)

export default component.exports